import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Trash2 } from "lucide-react";
import { BackupHistoryFilters, SortableDateHeader } from "./BackupHistoryFilters";
import { BackupHistoryRow } from "./BackupHistoryRow";

// Card "Histórico": filtros, toolbar de exclusão em lote e tabela de arquivos.
export function BackupHistoryTable({ files, rows, hist, empresas, canDeleteBackup, actions, onRestore }) {
  const { selected } = actions;
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between gap-3 flex-wrap">
        <CardTitle className="text-base">Histórico</CardTitle>
        <div className="basis-full order-last">
          <BackupHistoryFilters f={hist} empresas={empresas} total={files.length} shown={rows.length} />
        </div>
        {canDeleteBackup && selected.size > 0 && <BulkDeleteToolbar actions={actions} />}
      </CardHeader>
      <CardContent className="overflow-x-auto p-0">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-y">
            <tr className="text-left">
              {canDeleteBackup && (
                <th className="px-3 py-2 w-10">
                  <Checkbox checked={rows.length > 0 && rows.every((f) => selected.has(f.filename))}
                    onCheckedChange={actions.toggleSelectAll} aria-label="Selecionar todos os backups" data-testid="checkbox-select-all" />
                </th>
              )}
              <th className="px-4 py-2 font-semibold">Arquivo</th>
              <SortableDateHeader sortDir={hist.sortDir} onToggle={hist.toggleSort} />
              <th className="px-4 py-2 font-semibold">Tamanho</th>
              <th className="px-4 py-2 font-semibold">Status</th>
              <th className="px-4 py-2 font-semibold">Origem</th>
              <th className="px-4 py-2 font-semibold text-right">Ação</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && files.length > 0 && (
              <tr><td colSpan={7} className="px-4 py-8 text-center text-muted-foreground text-sm" data-testid="hist-empty-filtered">Nenhum backup no filtro selecionado.</td></tr>
            )}
            {rows.map((f) => (
              <BackupHistoryRow key={f.filename} f={f} canDeleteBackup={canDeleteBackup} actions={actions} onRestore={onRestore} />
            ))}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
}

function BulkDeleteToolbar({ actions }) {
  const { selected, bulkDeleting, clearSelection, bulkDelete } = actions;
  return (
    <div className="flex items-center gap-2" data-testid="bulk-delete-toolbar">
      <span className="text-xs text-slate-600 font-semibold">{selected.size} selecionado{selected.size > 1 ? "s" : ""}</span>
      <Button size="sm" variant="outline" onClick={clearSelection} disabled={bulkDeleting} className="h-8" data-testid="btn-clear-selection">Limpar</Button>
      <Button size="sm" onClick={bulkDelete} disabled={bulkDeleting} className="h-8 bg-rose-600 hover:bg-rose-700 text-white" data-testid="btn-bulk-delete">
        <Trash2 className={`w-3.5 h-3.5 mr-1.5 ${bulkDeleting ? "animate-pulse" : ""}`} />
        {bulkDeleting ? "Excluindo…" : `Excluir selecionados (${selected.size})`}
      </Button>
    </div>
  );
}
